<template>
  <v-card>
    <v-toolbar
      dark
      style="background-color: #fddf00; color: black"
      class="elevation-0"
    >
      <v-spacer></v-spacer>
      <v-toolbar-title><h4>Detail</h4> </v-toolbar-title>
      <v-spacer></v-spacer>
    </v-toolbar>
    <v-layout row wrap style="padding: 35px" justify-center>
      <v-flex xs12 sm4>
        <div style="text-align: center"><h2>weserve</h2></div>
        <div style="display: flex; justify-content: center">
          <img src="@/assets/bank-com.png" />
        </div>
        <div style="padding: 5px">
          <div class="text">Bank name</div>
          <div style="display: flex">
            <img
              :src="detailWithdraw.bank_weserve.bank_weserve_bank.bank_icon"
              style="width:30px; height: 27px;"
            />
            <h3 style="padding: 2px">
              {{ detailWithdraw.bank_weserve.bank_weserve_bank.bank_name_en }}
            </h3>
          </div>
        </div>
        <div style="padding: 5px">
          <div class="text">Bank number</div>
          <h3>
            {{ detailWithdraw.bank_weserve.bank_weserve_account_number }}
          </h3>
        </div>
        <div style="padding: 5px">
          <div class="text">Account name</div>
          <h3>{{ detailWithdraw.bank_weserve.bank_weserve_account_name }}</h3>
        </div>
      </v-flex>
      <v-flex xs12 sm4>
        <div style="display: flex; justify-content: center; margin-top: 30px;">
          <img
            src="@/assets/transactionlogo.png"
            v-if="$vuetify.breakpoint.xs"
            style="height: 30px;transform: rotate(0.25turn);"
          />
          <img src="@/assets/transactionlogo.png" v-else />
        </div>
        <div
          style="
                    display: flex;
                    margin-top: 15px;
                    justify-content: center;
                    margin-top: 10px;
                  "
        >
          <h3 style="margin-right:10px">Status:</h3>
          <h3
            :style="{
              color:
                detailWithdraw.status == 1
                  ? '#fbd200'
                  : detailWithdraw.status == 2
                  ? ' #4caf50'
                  : detailWithdraw.status == 3
                  ? ' #f44336'
                  : detailWithdraw.status == 4
                  ? '#f44336'
                  : null,
            }"
          >
            {{
              detailWithdraw.status == 1
                ? "PADDING"
                : detailWithdraw.status == 2
                ? "APPROVE"
                : detailWithdraw.status == 3
                ? "REJECT"
                : detailWithdraw.status == 4
                ? "DELETE"
                : null
            }}
          </h3>
        </div>
        <div style="padding: 50px;">
          <v-text-field
            disabled
            v-if="detailWithdraw.status == 3"
            type="text"
            :placeholder="detailWithdraw.remark"
            outline
          ></v-text-field>
        </div>
      </v-flex>
      <v-flex
        xs12
        sm4
        :style="{
          marginTop: this.$vuetify.breakpoint.xs ? '50px' : null,
        }"
      >
        <div style="text-align: center"><h2>weserve</h2></div>
        <div style="display: flex; justify-content: center">
          <img src="@/assets/wlletbank.png" />
        </div>
        <div style="padding: 5px">
          <div class="text">Bank name</div>
          <div style="display: flex">
            <img
              :src="detailWithdraw.bank_manager.bank_manager_bank.bank_icon"
              style="width:30px; height: 27px;"
            />
            <h3 style="padding: 2px">
              {{ detailWithdraw.bank_manager.bank_manager_bank.bank_name_en }}
            </h3>
          </div>
        </div>
        <div style="padding: 5px">
          <div class="text">Bank number</div>
          <h3>
            {{ detailWithdraw.bank_manager.bank_manager_bank_number }}
          </h3>
        </div>
        <div style="padding: 5px">
          <div class="text">Account name</div>
          <h3>{{ detailWithdraw.bank_manager.bank_manager_customer_name }}</h3>
        </div>
      </v-flex>
    </v-layout>
    <v-divider class="mx-4"></v-divider>
    <v-layout justify="space-between" style="padding:35px">
      <v-flex xs12 sm6>
        <div style="display: flex; justify-content: start">
          <div>
            <h3>Withdraw</h3>
            <h3 style="color: red">Commission</h3>
            <h3 style="color: green">Total</h3>
          </div>
        </div>
      </v-flex>
      <v-flex xs12 sm6>
        <div style="display: flex; justify-content: end">
          <div>
            <h3>{{ `${detailWithdraw.withdraw_price} THB` }}</h3>
            <h3 style="color: red">
              {{ `${detailWithdraw.commission_price} THB` }}
            </h3>
            <h3 style="color: green">
              {{ `${detailWithdraw.total_price} THB` }}
            </h3>
          </div>
        </div>
      </v-flex>
    </v-layout>
  </v-card>
</template>

<script>
import { mapState } from "vuex";

export default {
  data() {
    return {
      dialog: false,
    };
  },
  computed: {
    ...mapState({
      detailWithdraw: (state) => state.fetchUserBack.settransactionWithdraw,
    }),
  },
};
</script>
